module.exports = __webpack_public_path__ + "img/Writefull+Logo+Padding+250.d45cf268.png";